import { PropertyInformationDialog } from "src/components/PropertyInformationDialog";
import { closeWindow, ManagedWindow, WindowId } from "./WindowState";
import { ObliqueViewer } from "src/components/ObliqueViewer";
import { SearchWindow } from "src/compentsModus/SearchWindow";
import { PlotScreen } from "src/components/PlotScreen";
import OwnershipDiagram from "src/compentsModus/OwnershipDiagram";
import { BNBOAreaViewerDialog } from "src/modules/BNBOModule/BNBOAreaViewerDialog";
import { BnboDialog } from "src/modules/BNBOModule/BNBODialog";
import { BNBOOpgørelse } from "src/modules/BNBOModule/BNBOOpgørelse";
import {
  BNBOSingleInfo,
  BNBOSFEStatus,
} from "src/modules/BNBOModule/BNBOSFEStatus";
import { useWindowContext } from "./useWindowContext";

import { JPBWindow } from "src/modules/JPBModule/JPBWindow";
import { JPBTimeHorizonWindow } from "src/modules/JPBModule/JPBTimeHorizonWindow";
import { JPBIndexBuilderWindow } from "src/modules/JPBModule/JPBIndexBuilderWindow";
import { JPBPriceIndexSourceWindow } from "src/modules/JPBModule/JPBPriceIndexSourceWindow";
import { JPBSkovDemoWindow } from "src/modules/JPBSkovDemoModule/JPBSkovDemoWindow";

import {
  LoadedSettingsWindow,
  PersistenceScope,
  SettingsManager,
} from "@viamap/viamap2-common";
import { UserCustomerSettingsEditor } from "src/components/UserCustomerSettingsEditor";
import { BNBOAAreaEditorDialog } from "src/modules/BNBOModule/BNBOAAreadEditorDialog";
import {
  GenerateReportDialog,
  SpatialExportDialog,
} from "src/components/SpatialFunctionDialog";
import { StreetViewerUP } from "src/components/StreetViewer";
import { SelectCircle } from "src/components/SelectCircle";
import { SimulateOtherUserDialog } from "src/components/SimulateOtherUserDialog";
import { UserAccessRightsWindow } from "src/components/UserAccessRightsWindow";
import { MapStyling } from "src/components/MapStyling";
import { GDPRNoticeApproval } from "src/components/GDPRNoticeApproval";
import { DownloadDialog } from "src/components/DownloadDialog";
import { NameOnCreation } from "src/components/NameOnCreation";
import { ReportResultDialog } from "src/components/ReportResultDialog";
import { InfoScreen } from "src/components/InfoScreen";
import { CondominiumDialog } from "src/propertyInfoTemplates/CondominiumDialog";
import { CompanyInformationDialog } from "src/components/CompanyInformationDialog";
import { PersonInformationDialog } from "src/components/PersonInformationDialog";
import { CloudLayerList } from "src/components/CloudLayerList";
import {
  SaveMapAsCloudLinkDialog,
  SaveMapAsLinkDialog,
  SaveMapAsMapitDialog,
  SaveMapAsPrivateCloudDialog,
} from "src/components/SaveDialogs";
import { MaplinkOverview } from "src/components/MapLinkOverview";
import { DataRapportDialog } from "src/components/Datarapport";
import { SavedMapDialog } from "src/components/ReadOnlyMapDialog";
import { MultiPointTravelDialog } from "src/components/MultiPointTravelDialog";
import { ChatWindow } from "src/components/ChatWindow";
import { MapDescription } from "src/components/MapDescription";
import {
  JobServiceJobCreator,
  JobServiceLog,
  JobServiceMailExample,
  JobServiceTaskInfo,
  JobServiceTaskList,
  JobserviceInsiderWindow,
} from "src/modules/JobModule/JobServiceInsiderWindow";
import { JobInstiationTypeDialog } from "src/modules/JobModule/JobInstiantiationTypeDialog";
import { ConfirmationDialog } from "src/components/ConfirmationDialog";
import { ImportPrevSettings } from "src/components/ImportPrevSettings";
import { NameOnExport } from "src/components/NameOnExport";
import { BNBOStatusEditor } from "src/modules/BNBOModule/BNBOStatusEditor";
import { PlotLogoEditor } from "src/components/PlotLogoEditor";
import { ServitutErklaering } from "src/components/ServitutErklaering";
import { ServitutDetailsView } from "src/propertyInfoTemplates/ServitutDetailsView";
import { BroadcastReceiverDebug } from "src/components/BroadcastReceiverDebug";
import { DemoSideComponents } from "src/componentsUtils/DemoSideComponents";
import { PopupSettingsCustomizer } from "src/components/PopupSettingsCustomizer";
import { ConflictSearchDialog } from "src/components/ConflictSearchDialog";
import ConflictSearchResults from "src/components/ConflictSearchResults";
import { ANNImageOverlayDebugWindow } from "src/modules/ANNModule/ANNImageOverlayDebugWindow";
import { AdkomstDetailsView } from "src/propertyInfoTemplates/AdkomstDetailsView";
import { FRPAnotationsDialog } from "src/modules/FRPModule/FRPAnotationsDialog";
import { FRPDocuments } from "src/modules/FRPModule/FRPDocuments";
import { FRPExportToExcel } from "src/modules/FRPModule/FRPExportToExcel";
import { FRPImportDialog } from "src/modules/FRPModule/FRPImportDialog";
import { FRPMainDialog } from "src/modules/FRPModule/FRPMainDialog";
import { FRPSearchWindow } from "src/modules/FRPModule/FRPSearchWindow";
import { FRPStatusEditor } from "src/modules/FRPModule/FRPStatusEditor";
import { FRPTagEditor } from "src/modules/FRPModule/FRPTagEditor";
import { FRPAdminDialog } from "src/modules/FRPModule/FRPAdminDialog";
import { OpslagsVindue } from "src/components/OpslagsVindue";
import { GraphQLDemo } from "src/components/GraphQLDemo";
import { PDFInspector } from "src/components/PDFInspector";
import { ANNEditor } from "src/modules/ANNModule/ANNEditor";
import { ANNControlPanel } from "src/modules/ANNModule/ANNControlPanel";
import { ANNPDFViewer } from "src/modules/ANNModule/ANNPDFViewer";
import { LayerTester } from "src/components/LayerTester";
import { DemoSideIcons } from "src/componentsUtils/DemoSideIcons";
import { DownloadManager } from "src/components/DownloadManager";
import { ConflictReportDialog } from "src/components/ConflictReportDialog";
import { LayerFunctions } from "src/components/LayerFunctions";
import { ServitutRedegoerelseWindow } from "src/components/ServitutRedegoerelseRapport";

// <></> is handle elsewhere

export function WindowInstances({
  window,
}: {
  window: ManagedWindow;
}): JSX.Element | null {
  const { dispatch: windowDispath } = useWindowContext();

  if (typeof window.id !== "number") {
    return (
      <div style={{ position: "absolute", left: "50%" }}>
        Window not found {window.id}{" "}
      </div>
    );
  }

  switch (window.id) {
    case WindowId.ConfirmationDialog:
      return (
        <ConfirmationDialog
          showWindow={1}
          cookieTag={window.windowParams.cookieTag}
          header={window.windowParams.header}
          defaultChecked={window.windowParams.defaultChecked}
          onSubmit={() => {
            window.windowParams.onSubmit?.();
            windowDispath(closeWindow(window.id));
          }}
          onCancel={() => {
            window.windowParams.onCancel?.();
            windowDispath(closeWindow(window.id));
          }}
        >
          {window.windowParams.children}
        </ConfirmationDialog>
      );
    case WindowId.ImportPrevSettings:
      return (
        <ImportPrevSettings
          managedWindow={window}
          fileName={window.windowParams.fileName}
          sheetAnalysisResult={window.windowParams.sheetAnalysisResult}
          worksheet={window.windowParams.worksheet}
          sourcePrompt={window.windowParams.sourcePrompt}
          savedColumnMapping={window.windowParams.savedColumnMapping}
          savedLayerType={window.windowParams.savedLayerType}
          savedImportTransformation={window.windowParams.savedImportTransformation}
          onSubmit={(evt) => {
            window.windowParams.onSubmit?.(evt);
            windowDispath(closeWindow(window.id));
          }}
          onStartOver={(evt) => {
            window.windowParams.onStartOver?.(evt);
            windowDispath(closeWindow(window.id));
          }}
          onCancel={(evt) => {
            window.windowParams.onCancel?.(evt);
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.ChatWindow:
      return (
        <ChatWindow
          window={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.MapDescription:
      return (
        <MapDescription
          window={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.ShowSearchField:
      return <div>Search Field</div>;
    case WindowId.InformationWindow:
      return (
        <InfoScreen
          managedWindow={window}
          onFormClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.GettingStarted:
      return null;
      return <div>Getting Started</div>;
    case WindowId.ShowReleases:
      return null;
      return <div>Show Releases</div>;
    case WindowId.Legend:
      return <></>;
    case WindowId.ShowLegendButton:
      return <></>;
    case WindowId.EjendomskortDialog:
      return (
        <DataRapportDialog
          managedWindow={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.Servituterklaering:
      return <ServitutErklaering managedWindow={window} />;
    case WindowId.ServitutDetails:
      return <ServitutDetailsView managedWindow={window} />;
    case WindowId.AdkomstDetails:
      return <AdkomstDetailsView managedWindow={window} />;
    case WindowId.DemographyReportDialog:
      return (
        <GenerateReportDialog
          showWindow={1}
          onClose={() => {
            windowDispath(closeWindow(window.id));
          }}
          callbackOnReport={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.JPBTool:
      return <JPBWindow managedWindow={window} />;
    case WindowId.JPBTimeHorizon:
      return <JPBTimeHorizonWindow managedWindow={window} />;
    case WindowId.JPBIndexBuilder:
      return <JPBIndexBuilderWindow managedWindow={window} />;
    case WindowId.JPBPriceIndexSource:
      return <JPBPriceIndexSourceWindow managedWindow={window} />;
    case WindowId.JPBSkovDemo:
      return <JPBSkovDemoWindow managedWindow={window} />;
    case WindowId.StreetView:
      return (
        <StreetViewerUP
          managedWindow={window}
          onFormClose={() => {
            windowDispath(closeWindow(window.id));
          }}
          latlng={window.windowParams}
        />
      );
    case WindowId.SelectCircle:
      return <SelectCircle />;
    case WindowId.GenerateReportDialog:
      return (
        <GenerateReportDialog
          managedWindow={window}
          callbackOnCancel={() => {
            windowDispath(closeWindow(window.id));
          }}
          callbackOnReport={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.GenerateReportResultDialog:
      return (
        <ReportResultDialog
          managedWindow={window}
          onClose={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.PropertyInformationDialog:
      return (
        <PropertyInformationDialog
          managedWindow={window}
          bfeNr={window.windowParams?.bfeNr}
          ejerlavskode={window.windowParams?.ejerlavskode}
          matrnr={window.windowParams?.matrnr}
          allowExtendedInformation={true}
          cols={2}
        />
      );
    case WindowId.CompanyInformationDialog:
      return (
        <CompanyInformationDialog
          managedWindow={window}
          cvrNr={window.windowParams?.cvrNr || 0}
          callBackOnClose={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.ObliqueViewer:
      return (
        <ObliqueViewer
          managedWindow={window}
          imageProps={window.windowParams}
          onFormClose={() => { }}
        />
      );
    case WindowId.SaveMapDialog:
      return <SaveMapAsMapitDialog />;
    case WindowId.SaveLinkDialog:
      return <SaveMapAsLinkDialog />;
    case WindowId.SavedLinkDialog:
      return (
        <SavedMapDialog
          managedWindow={window}
          refLink={window.windowParams.ref || "test"}
          expireDate={window.windowParams.expireDate || new Date()}
          callbackOnCancel={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.CatchmentSelector:
      return <></>;
    case WindowId.SpatialSelection:
      return (
        <SpatialExportDialog
          managedWindow={window}
          onClose={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.CustomerSettingsEditor:
      return (
        <UserCustomerSettingsEditor
          scope={PersistenceScope.Customer}
          managedWindow={window}
        />
      );
    case WindowId.UserSettingsEditor:
      return (
        <UserCustomerSettingsEditor
          scope={PersistenceScope.User}
          managedWindow={window}
        />
      );
    case WindowId.MapSettingsEditor:
      return (
        <MapStyling
          managedWindow={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.PointDistanceTable:
      return (
        <MultiPointTravelDialog
          managedWindow={window}
          options={window.windowParams}
          callbackOnClose={() => {
            //  catchmentState.layerHandle && mapitState.map.removeLayerByHandle(catchmentState.layerHandle);
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.ConfirmLayerList:
      return null;
      return <div>Confirm Layer List</div>;
    case WindowId.FileTooBig:
      return null;
      return <div>File Too Big</div>;
    case WindowId.NameOnCreation:
      return (
        <NameOnCreation
          managedWindow={window}
          layers={window.windowParams.layers}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.NameOnExport:
      return (
        <NameOnExport
          managedWindow={window}
          onConfirm={(name) => {
            window.windowParams.onConfirm(name);
            windowDispath(closeWindow(window.id));
          }}
          onClose={() => windowDispath(closeWindow(window.id))}
          defaultNames={window.windowParams.defaultNames}
        />
      );
    case WindowId.DownloadLayerDialog:
      return (
        <DownloadDialog
          managedWindow={window}
          layers={window.windowParams.layers}
          callBack={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.GDPRNoticeApproval:
      return (
        <GDPRNoticeApproval
          managedWindow={window}
          currentCookie={window.windowParams.cookie}
          acceptText={window.windowParams.acceptText}
          callbackOnCancel={() => {
            windowDispath(closeWindow(window.id));
          }}
          callbackOnCommit={() => {
            window.windowParams.acceptCallback();
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.Explore:
      return <SearchWindow managedWindow={window} callbackOnClose={() => { }} />;
    case WindowId.PlotScreen:
      return (
        <PlotScreen
          managedWindow={window}
          callbackOnClose={() => { }}
          externalSettings={window.windowParams?.externalSettings as any}
        />
      );
    case WindowId.MapPlotLogoEditor:
      return <PlotLogoEditor
        managedWindow={window}
        value={window.windowParams?.value}
        onChange={(value) => {
          window.windowParams?.onChange?.(value);
          windowDispath(closeWindow(window.id));
        }}
        default={window.windowParams?.default}
        disabled={window.windowParams?.disabled}
      />
    case WindowId.LoadedSettings:
      return (
        <LoadedSettingsWindow
          show={true}
          bucket={SettingsManager.getSystemSetting("viamapStoreS3Bucket")}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.UserAccessRights:
      return (
        <UserAccessRightsWindow
          managedWindow={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.SimulateOtherUser:
      return (
        <SimulateOtherUserDialog
          managedWindow={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.CloudSaveDialog:
      return <SaveMapAsPrivateCloudDialog />;
    case WindowId.ViewCloudSaveDialog:
      return (
        <CloudLayerList
          show={true}
          close={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.AdminCloudSaveDialog:
      return <SaveMapAsCloudLinkDialog />;
    case WindowId.PersonInformationDialog:
      return (
        <PersonInformationDialog
          managedWindow={window}
          personInfo={window.windowParams}
          callBackOnClose={() => {
            windowDispath(closeWindow(window.id));
          }}
        />
      );
    case WindowId.OwnerShipDiagram:
      return <OwnershipDiagram managedWindow={window} search={window.windowParams} />;
    case WindowId.CondominiumDialog:
      return (
        <CondominiumDialog
          managedWindow={window}
          bfeNr={window.windowParams as { bfeNr: string }}
          callBackOnClose={() => {
            windowDispath(closeWindow(window.id));
          }}
          allowExtendedInformation={true}
        />
      );
    case WindowId.MapLinkOverview:
      return (
        <MaplinkOverview
          managedWindow={window}
          close={() => windowDispath(closeWindow(window.id))}
        />
      );

    case WindowId.ConflictSearchDialog:
      return (
        <ConflictSearchDialog
          window={window}
        />
      )

    case WindowId.ConflictSearchResults:
      return (
        <ConflictSearchResults
          window={window}
        />
      );
    case WindowId.DebugLayerTester:
      return (
        <LayerTester window={window} />
      )
    case WindowId.Opslag:
      return (
        <OpslagsVindue window={window} />
      )
    case WindowId.GraphQLDemo:
      return (
        <GraphQLDemo window={window} />
      );
    case WindowId.PDFInspector:
      return (
        <PDFInspector window={window} />
      );
    case WindowId.DownloadManager:
      return (
        <DownloadManager window={window} />
      );

    // ----------------- BNBOModule -----------------
    // region BNBOModule

    case WindowId.BNBODialog:
      return <BnboDialog showWindow={1} onFormClose={() => { }} />;
    case WindowId.BNBOAreaEditor:
      return (
        <BNBOAAreaEditorDialog
          showWindow={1}
          managedWindow={window}
          lodsejerId={window.windowParams?.lodsejerId as string}
        // markId={window.windowParams?.markId as string}
        />
      );
    case WindowId.BNBOMarkAreaEditor:
      return (
        <BNBOAAreaEditorDialog
          showWindow={1}
          managedWindow={window}
          lodsejerId={window.windowParams?.lodsejerId as string}
        // markId={window.windowParams?.markId as string}
        />
      );
    case WindowId.ConflictReportDialog:
      return (
        <ConflictReportDialog
          window={window}
        />
      );
    case WindowId.BNBOSingleElement:
      return (
        <BNBOSingleInfo
          show={1}
          managedWindow={window}
          lodsejerId={window.windowParams?.lodsejerId as any}
          onClose={() => { }}
        />
      );
    case WindowId.BNBOSFEStatus:
      return (
        <BNBOSFEStatus
          show={1}
          onClose={() => { }}
          managedWindow={window}
          filterBy={window.windowParams?.filterBy}
        />
      );
    case WindowId.BNBOOpgørelse:
      return (
        <BNBOOpgørelse
          show={1}
          onClose={() => { }}
          lodsejerId={window.windowParams?.lodsejerId}
        />
      );
    case WindowId.BNBOAreaViewer:
      return (
        <BNBOAreaViewerDialog
          showWindow={1}
          lodsejerId={window.windowParams?.lodsejerId as string}
          defaultModus={window.windowParams?.defaultModus}
        />
      );
    case WindowId.BNBOStatusEditor:
      return (
        <BNBOStatusEditor
          managedWindow={window}
          value={window.windowParams?.value}
          onChange={(value) => {
            window.windowParams?.onChange?.(value);
            windowDispath(closeWindow(window.id));
          }}
          default={window.windowParams?.default}
          disabled={window.windowParams?.disabled}
        />
      );
    case WindowId.DemoSideComponents:
      return (
        <DemoSideComponents onClose={() => windowDispath(closeWindow(window.id))} />
      );
    case WindowId.DemoSideIconsMIB:
      return (
        <DemoSideIcons managedWindow={window} />
      );
    case WindowId.ImageOverlayDebug:
      return <ANNImageOverlayDebugWindow window={window} />;
    case WindowId.BroadcastReceiverDebug:
      return (
        <BroadcastReceiverDebug
          window={window}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    case WindowId.PopupSettingsCustomizer:
      return (
        <PopupSettingsCustomizer
          managedWindow={window}
          layerId={window.windowParams.layerId}
          onClose={() => windowDispath(closeWindow(window.id))}
        />
      );
    // #region Jobs Module
    case WindowId.JobServiceInsider:
      return <JobserviceInsiderWindow window={window} />
    case WindowId.JobServiceLog:
      return <JobServiceLog window={window} />
    case WindowId.JobServiceJobCreator:
      return <JobServiceJobCreator window={window} />
    case WindowId.JobServiceTaskList:
      return <JobServiceTaskList window={window} />
    case WindowId.JobServiceTaskInfo:
      return <JobServiceTaskInfo window={window} />
    case WindowId.JobServiceMailExample:
      return <JobServiceMailExample window={window} />
    case WindowId.JobsDialog:
    case WindowId.JobsAdminDialog:
      return <JobInstiationTypeDialog
        managedWindow={window}
        onFormClose={() => { }}
      />
    // #region FRP Module
    case WindowId.FRPSearch:
      return <FRPSearchWindow
        managedWindow={window}
        callbackOnClose={() => { }}
      />
    case WindowId.FRPImport:
      return <FRPImportDialog
        managedWindow={window}
        callbackOnClose={() => { }}
      />
    case WindowId.FRPStatusEditor:
      return <FRPStatusEditor
        managedWindow={window}
        disabled={window.windowParams?.disabled}
      />
    case WindowId.FRPTagEditor:
      return <FRPTagEditor
        managedWindow={window}
        disabled={window.windowParams?.disabled}
      />
    case WindowId.FRPMainDialog:
      return <FRPMainDialog
        show={1}
        onClose={() => { }}
        managedWindow={window}
        filterBy={window.windowParams?.filterBy}
      />
    case WindowId.FRPAnnoteringsDialog:
      return <FRPAnotationsDialog
        managedWindow={window}
      />
    case WindowId.FRPDocuments:
      return <FRPDocuments
        managedWindow={window}
        callbackOnClose={() => windowDispath(closeWindow(window.id))}
      />
    case WindowId.FRPExportToExcel:
      return <FRPExportToExcel
        managedWindow={window}
        disabled={window.windowParams?.disabled}
      />
    case WindowId.FRPAdminDialog:
      return <FRPAdminDialog
        managedWindow={window}
        onFormClose={() => windowDispath(closeWindow(window.id))}
      />
    case WindowId.ANNEditor:
      return <ANNEditor
        managedWindow={window}
      />
    case WindowId.ANNUnverifiedAnnotations:
      return <ANNControlPanel
        managedWindow={window}
      />
    case WindowId.ANNPDFAnalyzerViewer:
      return <ANNPDFViewer
        managedWindow={window}
      />
    case WindowId.LayerFunctions:
      return <LayerFunctions
        window={window}
      />
    case WindowId.ServitutRedegoerelse:
      return <ServitutRedegoerelseWindow
        managedWindow={window}
      />
    default:
      return <div>Window not found</div>
  }
}
